// extracted by mini-css-extract-plugin
export default {"confirmModal":"AddBankDetailsModal__confirmModal-vSHR"};